import React from 'react';
import { LOCALYSER_WEBSITE_URL } from '../../../constants/links';
import style from './style.module.css';

const RequestFooter = ({ powered }) => {
  return (
    <p className={style.poweredByWrapper}>
      {powered}&nbsp;
      <a href={LOCALYSER_WEBSITE_URL} target="_blank" rel="noopener noreferrer" className={style.brandLink}>
        <strong className={style.brandName}>Localyser</strong>
      </a>
    </p>
  );
};

export default RequestFooter;
